export { default } from './DrawDocumentsSection';
